import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InfoComponent } from './modules/info/info.component';
import { environment } from '../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { LoyalticInterceptor } from './core/interceptor/interceptor';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { LandingComponent } from './modules/campaign/landing/landing.component';
import { PlayComponent } from './modules/campaign/play/play.component';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { FeedbackComponent } from './modules/support/feedback/feedback.component';
import { FeedbackSuccessComponent } from './modules/support/feedback-success/feedback-success.component';
import { CookieService } from 'ngx-cookie-service';
import { SharedModule } from './modules/shared/shared.module';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Loyaltic } from './core/helpers/api-url.constants';
import { AdminComponent } from './modules/admin/admin.component';
import { FooterComponent } from './modules/page-layout/footer/footer.component';
import { HeaderComponent } from './modules/page-layout/header/header.component';
import { SupportRulesComponent } from './modules/support/support-rules/support-rules.component';
import { SupportPolicyComponent } from './modules/support/support-policy/support-policy.component';
import { LayoutComponent } from './modules/page-layout/layout/layout.component';
import { ParticipateWithEmailComponent } from './modules/campaign/participate-with-email/participate-with-email.component';
import { ParticipateWithPhoneComponent } from './modules/campaign/participate-with-phone/participate-with-phone.component';
import { ParticipateWithEmailAndReceiptComponent } from './modules/campaign/participate-with-email-and-receipt/participate-with-email-and-receipt.component';
import { ParticipateWithPhoneAndReceiptComponent } from './modules/campaign/participate-with-phone-and-receipt/participate-with-phone-and-receipt.component';
import { NoWinComponent } from './modules/campaign/play/no-win/no-win.component';
import { WinComponent } from './modules/campaign/play/win/win.component';
import { DeliverableWinComponent } from './modules/campaign/play/win/deliverable-win/deliverable-win.component';
import { DigitalWinComponent } from './modules/campaign/play/win/digital-win/digital-win.component';
import { EmailReminderComponent } from './modules/shared/email-reminder/email-reminder.component';
import { LocalizationComponent } from './modules/shared/localization/localization.component';
import { GenericPopUpComponent } from './modules/popups/generic-pop-up/generic-pop-up.component';
import { UploadReceiptComponent } from './modules/campaign/upload-receipt/upload-receipt.component';
import { ConfirmReceiptUploadComponent } from './modules/popups/confirm-receipt-upload/confirm-receipt-upload.component';
import { ClickToPlayComponent } from './modules/campaign/click-to-play/click-to-play.component';
import { DevNavigationComponent } from './modules/dev-navigation/dev-navigation.component';
import { CookieComponent } from './modules/support/cookie/cookie.component';
import { UploadAnimationPopUpComponent } from './modules/popups/upload-animation-pop-up/upload-animation-pop-up.component';
import { LoyalticMissingTranslationHandler } from './core/handlers/LoyalticMissingTranslationHandler';
import { NotTranslatedService } from './core/helpers/not-translated-service.service';
import { CarouselComponent} from './modules/campaign/carousel/carousel.component';
import { ScratchCardComponent } from './modules/campaign/play/scratch-card/scratch-card.component';
import { SelectSlotComponent } from './modules/campaign/select-slot/select-slot.component';
import { EnterCodeComponent } from './modules/campaign/enter-code/enter-code.component';
import { HowToStepsComponent } from './modules/campaign/how-to-steps/how-to-steps.component';
import { WhatIsNewComponent } from './modules/campaign/what-is-new/what-is-new.component';
import { HowToComponent } from './modules/support/how-to/how-to.component';
import { CalendarComponent } from './modules/campaign/advent-calendar/components/calendar/calendar.component';
import { DayTileComponent } from './modules/campaign/advent-calendar/components/day-tile/day-tile.component';
import { RewardModalComponent } from './modules/campaign/advent-calendar/components/reward-modal/reward-modal.component';
import { SnowLayerComponent } from './modules/campaign/advent-calendar/components/snow-layer/snow-layer.component';
import { AnalyticsComponent } from './modules/analytics/analytics.component';
import { BaseChartDirective } from 'ng2-charts';
import {
  RecaptchaModule,
  RECAPTCHA_SETTINGS,
  RecaptchaSettings,
  RecaptchaFormsModule,
  RECAPTCHA_V3_SITE_KEY,
  RecaptchaV3Module
} from 'ng-recaptcha';

const RECAPTCHA_V2_DUMMY_KEY = '6LeD3xEsAAAAAJXTBObvLLIbDKkj2WTuWS8qdufk';

export class CustomLoader implements TranslateLoader {
  constructor(private http: HttpClient) { }
  getTranslation(lang: string): Observable<any> {
    return this.http.get(environment.baseUrl + Loyaltic.API.LocalizationByCulture + '?culture=' + lang).pipe(map(
      (res: any) => {
        const translation = {};
        res.forEach(element => {
          translation[element.key] = element.text;
        });
        return translation;
      })
    );
  }
}

@NgModule({ declarations: [
        ClickToPlayComponent,
        UploadReceiptComponent,
        LocalizationComponent,
        EmailReminderComponent,
        DeliverableWinComponent,
        DigitalWinComponent,
        WinComponent,
        NoWinComponent,
        ParticipateWithPhoneAndReceiptComponent,
        ParticipateWithEmailAndReceiptComponent,
        ParticipateWithPhoneComponent,
        ParticipateWithEmailComponent,
        AppComponent,
        InfoComponent,
        LandingComponent,
        PlayComponent,
        FeedbackComponent,
        FeedbackSuccessComponent,
        AdminComponent,
        HeaderComponent,
        FooterComponent,
        SupportRulesComponent,
        SupportPolicyComponent,
        LayoutComponent,
        GenericPopUpComponent,
        ConfirmReceiptUploadComponent,
        DevNavigationComponent,
        CookieComponent,
        UploadAnimationPopUpComponent,
        CarouselComponent,
        ScratchCardComponent,
        SelectSlotComponent,
        EnterCodeComponent,
        HowToStepsComponent,
        WhatIsNewComponent,
        HowToComponent,
        AnalyticsComponent,
        CalendarComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        ToastrModule.forRoot({ preventDuplicates: true }),
        FormsModule,
        ReactiveFormsModule,
        ModalModule.forRoot(),
        DayTileComponent,
        RewardModalComponent,
        SnowLayerComponent,
        BaseChartDirective,
        RecaptchaModule,
        RecaptchaFormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomLoader,
                deps: [HttpClient]
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: LoyalticMissingTranslationHandler,
                deps: [NotTranslatedService]
            }
        })], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: LoyalticInterceptor, multi: true },
        { provide: 'ImagePath', useValue: environment.ImagePath },
        { provide: 'googleTagManagerId', useValue: 'G-NZXX77C8D1' },
        {
          provide: RECAPTCHA_SETTINGS,
          useValue: {
            siteKey: RECAPTCHA_V2_DUMMY_KEY
          } as RecaptchaSettings
        },
        CookieService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
